<template>
  <layout-customs>
    <div id="page-content-wrapper" class="contact-form-container">
      <div class="container-fluid">
        <!--div class="container" -->
        <form v-if="!contactDone" class="container" data-vv-scope="contactForm" >

          <div class="row row-centered">
            <h1>Contact</h1>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-12">
              <textarea
                class="form-control"
                placeholder="Write you message here"
                name="message"
                v-validate="'required|min:50'"
                v-model="contact.message"
                data-vv-as="What problem"
                min="500"
                :class="{'error-input': errors.has('contactForm.message')}"
              >
              </textarea>
              <span
                v-if="errors.has('contactForm.message')"
                class="error"
              >{{ errors.first('contactForm.message') }}</span>
            </div>
            <div class="col-md-6 col-sm-12">
              <ul>
                <li>
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Name"
                    name="name"
                    v-validate="'required'"
                    v-model="contact.name"
                    data-vv-as="Name"
                    :class="{'error-input': errors.has('contactForm.name')}"
                  >
                  <span
                    v-if="errors.has('contactForm.name')"
                    class="error"
                  >{{ errors.first('contactForm.name') }}</span>
                </li>
                <li>
                  <input
                    class="form-control"
                    :class="{'error-input': errors.has('contactForm.email')}"
                    type="text"
                    placeholder="Email"
                    name="email"
                    v-validate="'required'"
                    v-model="contact.email"
                    data-vv-as="Email"
                  >
                  <span
                    v-if="errors.has('contactForm.email')"
                    class="error"
                  >{{ errors.first('contactForm.email') }}</span>
                </li>
                <li>
                  <input
                    class="form-control"
                    :class="{'error-input': errors.has('contactForm.subject')}"
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    v-validate="'required'"
                    v-model="contact.subject"
                    data-vv-as="Subject"
                  >
                  <span
                    v-if="errors.has('contactForm.subject')"
                    class="error"
                  >{{ errors.first('contactForm.subject') }}</span>
                </li>
                <li>
                    <a class="send-btn" v-on:click="send()">Send</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <p class="info">
              Or send us an email on <a href="mailto:info@greeneum.net">info@greeneum.net</a>
            </p>
          </div>
        </form>

        <div v-else class="container">
          <div class="row row-centered">
            <h1>Thank you!</h1>
          </div>
        </div>
      </div>
    </div>
  </layout-customs>
</template>

<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
import Api from './../../services/api'

export default {
  name: 'About',
  components: {
    LayoutCustoms,
  },
  data() {
    return {
      contact: {
        name: "",
        message: "",
        email: "",
        subject: "",
      },
      contactDone: false,
    }
  },
  methods: {
    async send() {
      try {
        let isValid = await this.$validator.validateAll('contactForm')
        if (!isValid) {
            return
        }

        let formData = new FormData()
        formData.append('name', this.contact.name)
        formData.append('email', this.contact.email)
        formData.append('subject', this.contact.subject)
        formData.append('message', this.contact.message)

        let response = await Api.sendContactForm(formData)
        this.contactDone = true

        console.log(response)
      } catch (error) {

        console.error(error)

        this.$toast.error({
          title: 'Error',
          message: error.message,
          color: '#a21010',
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact/index.vue